import { Role } from '../../../../shared-types/Roles';

export function GetRoleHelperPlainText(role: Role) {
  switch (role) {
    case Role.Student:
      return 'Can access their own personal data and interact with their success network.';
    case Role.PeerAdvisor:
      return 'Can access most* data about their assigned students and interact with them. Academics, some demographics and predictive scores are hidden from Peer Advisors.';
    case Role.Advisor:
      return 'Can access all data on their assigned students and interact with them.';
    case Role.Generalist:
      return 'Can access all data on all students and interact with them.';
    case Role.Executive:
      return 'Can access all student data, interact with any student, and run reports.';
    case Role.Administrator:
      return 'Can access all student data, interact with any student, run reports, and has full control of settings.';
    case Role.Support:
      return 'For Anthology administrators only.';
    default:
      return '';
  }
}
